import React from "react";
import { TodoList } from "./TodoList";
import "./TodoList.css";

const Home = () => {
  return (
    <main className="dashboard-page">
      <header className="dashboard-intro">
        <p className="dashboard-eyebrow">Your focus space</p>
        <h1>What will you work on next?</h1>
        <p>Add a task, put the list in the right order, then choose the mode that fits your day.</p>
      </header>
      <TodoList />
    </main>
  );
};

export default Home;
